import { css } from 'lit';
import { IxButton } from './IxButton.js';

export class IxButtonStyled extends IxButton {
  static override styles = css`
    .md-button {
      display: flex;
      --md-circular-progress-size: 24px;
    }

    .slot-wrap {
      font-family: var(
        --ix-button-font-family,
        var(--root-secondary-font, 'sans-serif')
      );
      font-weight: var(--ix-button-font-weight, bold);
      text-transform: var(--ix-button-text-transform, uppercase);
      position: relative;
      letter-spacing: var(--ix-button-letter-spacing, 1.25px);
    }

    :host {
      overflow: hidden;
    }

    :host(.login) {
      --md-filled-button-pressed-state-layer-color: var(
        --clr-secondary,
        #071454
      );
      --md-filled-button-pressed-state-layer-opacity: 1;
      --md-filled-button-hover-state-layer-color: var(--clr-secondary, #071454);
      --md-filled-button-hover-state-layer-opacity: 1;
      --md-filled-button-container-shape: 0;
    }

    :host(.critical),
    :host(.cancel) {
      --md-outlined-button-pressed-outline-color: var(
        --ix-button-pressed-clr-critical-outline,
        var(--clr-critical, #db0028)
      );

      --md-sys-color-on-primary: var(
        --ix-button-clr-on-critical,
        var(--clr-on-critical, #fff)
      );
      --md-sys-color-primary: var(
        --ix-button-clr-critical,
        var(--clr-critical, #db0028)
      );
      --md-outlined-button-outline-color: var(
        --ix-button-clr-critical-outline,
        var(--clr-critical, #db0028)
      );
      --md-filled-button-hover-state-layer-color: var(
        --ix-button-clr-critical-hover,
        var(--clr-critical-hover, #f83b3a)
      );
    }
  `;
}

window.customElements.define('ix-button', IxButtonStyled);
